import { render, staticRenderFns } from "./ConnectMetrics.vue?vue&type=template&id=655b6053&"
import script from "./ConnectMetrics.vue?vue&type=script&lang=js&"
export * from "./ConnectMetrics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports